"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Google = Google;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Google(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EDF0EF"
  }), (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.747 32c.066-.022.132-.055.209-.099l9.66-5.278-2.291-2.288L19.747 32zm10.287-5.608l-2.39-2.375 2.39-2.409 3.283 1.793c.804.44.396.99 0 1.21l-3.283 1.78zm-.43-5.026l-9.648-5.256c-.1-.055-.22-.088-.341-.11l7.699 7.676 2.29-2.31zM19.054 16.1l7.941 7.918L19.086 32c-.231-.143-.353-.462-.353-.869 0-.78-.066-13.229-.066-14.163-.01-.462.154-.737.386-.869z",
    fill: "#1F2D27"
  }));
}

Google.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Google"
};